import React, { lazy } from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function EarlyTestimonials() {
  const testimonials = [{
    name: 'Maria C.',
    quote: "Natural remedies finally make sense. I've stopped buying cold medicine constantly.",
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Elena G.',
    quote: 'My digestion improved more in 2 weeks than years of prescriptions.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=faces'
  }, {
    name: 'Kathy W.',
    quote: 'Easy recipes, ingredients from my kitchen. I feel better and sleep better.',
    image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=faces'
  }];
  return <section className="w-full bg-white py-16 md:py-20" data-id="element-206">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-207">
        <div className="text-center mb-12" data-id="element-208">
          <div className="flex items-center justify-center gap-1.5 mb-4" data-id="element-209">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-210" />)}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-211">
            Real Reader Results
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-212">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-stone-50 rounded-2xl p-6 md:p-8 border border-stone-100 flex flex-col h-full relative" data-id="element-213">
              <QuoteIcon className="w-8 h-8 text-emerald-200 mb-4" data-id="element-214" />
              <p className="text-stone-700 mb-8 leading-relaxed flex-grow text-lg" data-id="element-215">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto pt-5 border-t border-stone-200" data-id="element-216">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-emerald-100" loading="lazy" data-id="element-217" />
                <div data-id="element-218">
                  <p className="text-stone-900 font-bold text-base" data-id="element-219">
                    {testimonial.name}
                  </p>
                  <p className="text-emerald-600 text-sm font-medium" data-id="element-220">
                    Verified Reader
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}